export class RestoreGoogleWorkspaceGroupMessagesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "restoreTarget",
            "baseName": "restoreTarget",
            "type": "GoogleWorkspaceGroupMessageTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceGroupMessagesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
